export default __webpack_public_path__ + "static/media/icon_dots_vertical.22859a68.svg";